<div class="auth-wrapper">
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'forgotPassword.headline' | transloco }}</h1>

      @if (!submitted) {
        <p class="supporting">{{ 'forgotPassword.supporting' | transloco }}</p>
        <form [formGroup]="forgotForm" (ngSubmit)="submit()" novalidate>
          <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <mat-label>{{ 'common.form.emailLabel' | transloco }}</mat-label>
            <input matInput type="email" formControlName="email" maxlength="254" autocomplete="email"/>
            @if (forgotForm.get('email')?.hasError('required') && forgotForm.get('email')?.touched) {
              <mat-error>{{ 'common.errors.emailRequired' | transloco }}</mat-error>
            }
            @if (forgotForm.get('email')?.hasError('email') && forgotForm.get('email')?.touched) {
              <mat-error>{{ 'common.errors.emailInvalid' | transloco }}</mat-error>
            }
          </mat-form-field>

          <button mat-flat-button color="primary" type="submit"
                  [disabled]="forgotForm.invalid || loading">
            @if (loading) {
              {{ 'forgotPassword.submit.loading' | transloco }}
            } @else {
              {{ 'forgotPassword.submit.idle' | transloco }}
            }
          </button>

          <div class="login-link">
            {{ 'forgotPassword.rememberedIt' | transloco }} <a [routerLink]="['/']" queryParamsHandling="preserve">{{ 'common.backToSignIn' | transloco }}</a>
          </div>
        </form>
      } @else {
        <p class="confirmation">{{ 'forgotPassword.confirmation' | transloco }}</p>
        <div class="login-link">
          <a [routerLink]="['/']" queryParamsHandling="preserve">{{ 'common.backToSignIn' | transloco }}</a>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
